export async function fetchWidgetLeadFormById({
  apiBaseUrl,
  agentId,
  masterKey,
  formId,
  signal,
}) {
  const base = String(apiBaseUrl || '').replace(/\/$/, '')
  if (!base) throw new Error('apiBaseUrl is required')
  if (!agentId) throw new Error('agentId is required')
  if (!formId) throw new Error('formId is required')

  const mk =
    typeof masterKey === 'string' ? masterKey.trim() : String(masterKey || '').trim()

  const res = await fetch(`${base}/api/v1/widget/lead-forms/${encodeURIComponent(String(formId))}`, {
    method: 'POST',
    signal,
    credentials: 'omit',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      ...(mk ? { 'X-Master-Key': mk } : {}),
    },
    body: JSON.stringify({ agentId }),
  })

  if (!res.ok) {
    const text = await res.text().catch(() => '')
    throw new Error(
      `Lead form lookup failed (${res.status}): ${text || res.statusText || 'Unknown error'}`,
    )
  }

  const json = await res.json()
  const list = Array.isArray(json) ? json : Array.isArray(json?.data) ? json.data : []
  return list
}

